export default __webpack_public_path__ + "static/media/Gilroy-MediumItalic.e50c6ab1.woff";